import type { ProjectMixProjectRow } from '../types/projectAnalysis'
import type { DisplaySummaryRow } from './projectOverviewSummary'

export type OverviewHoursPieSlice = {
  name: string
  value: number
  color: string
}

export function computeOverviewHoursPieData(
  displaySummary: DisplaySummaryRow | null,
): OverviewHoursPieSlice[] {
  if (!displaySummary?.total_hours) return []
  const bh = Number(displaySummary.billable_hours) || 0
  const nb = Number(displaySummary.non_billable_hours) || 0
  if (bh + nb <= 0) return []
  return [
    { name: 'Billable', value: Math.round(bh * 100) / 100, color: '#0d9488' },
    {
      name: 'Non-Billable',
      value: Math.round(nb * 100) / 100,
      color: '#b45309',
    },
  ]
}

export type OverviewTopProjectBarRow = {
  name: string
  fullName: string
  hours: number
  billable: number
  util: number
}

export function computeOverviewTopProjectsBarData(
  categoryFilteredProjectList: ProjectMixProjectRow[],
): OverviewTopProjectBarRow[] {
  return categoryFilteredProjectList.slice(0, 8).map((p) => {
    const full = p.project_name || `Project ${p.project_id}`
    const name =
      full.length > 22
        ? `${(p.project_name || `P${p.project_id}`).slice(0, 20)}…`
        : full
    return {
      name,
      fullName: full,
      hours: Math.round((p.total_hours ?? 0) * 10) / 10,
      billable: Math.round((p.billable_hours ?? 0) * 10) / 10,
      util: p.utilization_pct ?? 0,
    }
  })
}

export type UtilDistributionBand = {
  name: string
  count: number
  fill: string
}

export function computeOverviewUtilDistribution(
  categoryFilteredProjectList: ProjectMixProjectRow[],
): UtilDistributionBand[] {
  const bands: UtilDistributionBand[] = [
    { name: '80%+ util', count: 0, fill: '#0d9488' },
    { name: '50–80%', count: 0, fill: '#ca8a04' },
    { name: '<50%', count: 0, fill: '#b45309' },
  ]
  categoryFilteredProjectList.forEach((p) => {
    const u = p.utilization_pct ?? 0
    if (u >= 80) bands[0].count++
    else if (u >= 50) bands[1].count++
    else bands[2].count++
  })
  return bands
}
